<template>
  <Alert
    v-if="hasAccess(ACCESS_TYPE.NONE)"
    type="warning"
    class="tw-rounded-none"
  >
    <template #description>
      <div v-if="hasTeamRole(TEAM_ROLE.OWNER)">
        Your team does not have a paid subscription.
        <InertiaLink href="/upgrade_plan/new">
          Click here to upgrade.
        </InertiaLink>
      </div>
      <div v-else-if="hasTeamRole(TEAM_ROLE.MEMBER)">
        Your team does not have a paid subscription. If you want to join the
        community,
        <InertiaLink class="tw-link" href="/settings/billing">click here</InertiaLink>
        to leave your team or ask your team owner to upgrade your team.
      </div>
      <InertiaLink v-else href="/upgrade_plan/new" @click="trackButtonClick">
        Upgrade to
        <span class="tw-font-medium">Pro membership</span>
        to join the community.
      </InertiaLink>
    </template>
  </Alert>
</template>

<script setup>
import Alert from '@/shared/components/Alert.vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { ACCESS_TYPE, TEAM_ROLE } from '@/shared/data/permissionSystem.js'

const { hasAccess, hasTeamRole } = usePermissionSystem()

const trackButtonClick = () => {
  window.segmentAnalytics.track('Upgrade to Pro link Clicked', {
    user_type: window.segmentAnalytics.userType(),
    link_source: 'Upgrade to pro flash message',
  })
}
</script>
